import { useTranslation } from "@/hooks/useTranslation"
import { EyeOutlined } from "@/icons"
import { Form } from "@/organisms/Form"
import { SpecificResources } from "@/organisms/Form/components/ResourcesSectionForm/components/SpecificResources"
import { getRules } from "@/pages/GovernancePage/components/pages/PolicyPage/components/helpers"
import { useGetOptionsSastGuidance } from "@/pages/SettingsPage/application/guidance/useGuidance"

import type { ResourcesGuidanceFormSectionProps } from "./ResourcesGuidanceFormSection.types"

export const ResourcesGuidanceFormSection = (
  props: ResourcesGuidanceFormSectionProps
) => {
  const { form } = Form.useForm()
  const { t } = useTranslation()
  const { t: tForm } = useTranslation("translation", {
    keyPrefix: "settings.kai-guidance.form.scope"
  })
  const optionsCtx = useGetOptionsSastGuidance()
  const scopes = optionsCtx.data?.scopes || []
  const { impactCtx } = props
  const disabled = impactCtx.isPending

  return (
    <Form.Section.Resources
      form={form}
      title={tForm("title")}
      Icon={EyeOutlined}
      disabled={disabled}
    >
      <SpecificResources
        onlyOne
        form={form}
        rules={getRules(t)}
        options={scopes}
        tForm={tForm}
      />
    </Form.Section.Resources>
  )
}
